import { PopoverListButton } from '@aibees/shared/components';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(PopoverListButton)`
  display: flex;
  align-items: center;
`;
